module.exports = "<div class=\"cms-creator-image-spinner__content animated\" ng-if=\"$ctrl.pending\">\n    <em class=\"fa fa-3x fa-circle-o-notch fa-spin\" ></em>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/ImageSpinner/imageSpinner.html
// module id = 1008
// module chunks = 0